import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { RitualTemplatesState } from './types';

export const getters: GetterTree<RitualTemplatesState, RootState> = {
  //
};
